"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonBoard = void 0;
const vue_1 = require("vue");
const SpaceType_1 = require("../../SpaceType");
const MoonSpace_1 = require("./MoonSpace");
class MoonParamLevel {
    constructor(value, isActive, strValue) {
        this.value = value;
        this.isActive = isActive;
        this.strValue = strValue;
    }
}
exports.MoonBoard = vue_1.default.component('moonboard', {
    props: {
        model: {
            type: Object,
        },
        automaSoloVariant: {
            type: Boolean,
        },
    },
    components: {
        'moon-space': MoonSpace_1.MoonSpace,
    },
    data: function () {
        return {};
    },
    methods: {
        getAllNonColonySpaces: function () {
            const boardSpaces = this.model.spaces;
            boardSpaces.sort((space1, space2) => {
                return parseInt(space1.id) - parseInt(space2.id);
            });
            return boardSpaces.filter((s) => {
                return s.spaceType !== SpaceType_1.SpaceType.COLONY;
            });
        },
        getSpaceById: function (spaceId) {
            for (const space of this.model.spaces) {
                if (space.id === spaceId) {
                    return space;
                }
            }
            throw 'Board space not found by id \'' + spaceId + '\'';
        },
        getValuesForParameter: function (targetParameter) {
            let curValue;
            switch (targetParameter) {
                case 'logistics':
                    curValue = this.model.logisticsRate;
                    break;
                case 'mining':
                    curValue = this.model.miningRate;
                    break;
                case 'colony':
                    curValue = this.model.colonyRate;
                    break;
                default:
                    throw 'Wrong parameter to get values from';
            }
            const values = [];
            for (let value = 8; value >= 0; value -= 1) {
                const strValue = value.toString();
                values.push(new MoonParamLevel(value, value === curValue, strValue));
            }
            if (this.automaSoloVariant === true) {
                for (let i = values.length - 2; i > 0; i -= 2) {
                    values[i] = new MoonParamLevel(values[i].value, false, '■');
                }
            }
            return values;
        },
        getScaleCSS: function (paramLevel, offset = false) {
            let css = offset ? 'global-numbers-value-offset' : 'global-numbers-value';
            css += ' val-' + paramLevel.value + ' ';
            if (offset && paramLevel.value === 0) {
                css += ' global-numbers-zero ';
            }
            else if (paramLevel.value === 0) {
                css += ' global-numbers-zero-with-margin ';
            }
            if (paramLevel.isActive) {
                css += 'val-is-active';
                if (offset && paramLevel.value > 0) {
                    css += ' val-adjusted-line-height ';
                }
            }
            return css;
        },
    },
    template: `
    <div class="board-cont moon-board" id="moon_board">
      <svg id="moon_board_legend" height="550" width="630" class="board-legend">
        <g id="mare_imbrium" transform="translate(250, 40)">
          <text class="board-caption">
            <tspan dy="15">Mare</tspan>
            <tspan x="12" dy="12">Imbrium</tspan>
          </text>
          <line x1="24" y1="34" x2="33" y2="105" class="board-line"></line>
          <text x="30" y="107" class="board-caption board_caption--black">●</text>
        </g>

        <g id="mare_sereitatis" transform="translate(485, 140)">
          <text class="board-caption">
              <tspan dy="15">Mare</tspan>
              <tspan x="4" dy="12">Serenitatis</tspan>
          </text>
          <line x1="0" y1="25" x2="-120" y2="50" class="board-line"></line>
          <text x="-122" y="53" class="board-caption board_caption--black">●</text>
        </g>


        <g id="mare_nubium" transform="translate(195, 350)">
          <text class="board-caption">
            <tspan dy="15">Mare</tspan>
            <tspan x="-2" dy="12">Nubium</tspan>
          </text>
          <line x1="29" y1="14" x2="115" y2="-64" class="board-line"></line>
          <text x="113" y="-62" class="board-caption board_caption--black">●</text>
        </g>

        <g id="mare_nectaris" transform="translate(450, 300)">
          <text class="board-caption" dx="47">
            <tspan dy="15">Mare</tspan>
            <tspan dy="12" x="48">Nectaris</tspan>
          </text>
          <line x1="-39" y1="-12" x2="45" y2="15" class="board-line"></line>
          <text x="-39" y="-9" class="board-caption board_caption--black">&#x25cf;</text>
        </g>
      </svg>

      <div class="board-outer-spaces">
        <moon-space :space="getSpaceById('m01')" text="Luna Trade Station"></moon-space>
        <moon-space :space="getSpaceById('m37')" text="Momentum Virium Habitat"></moon-space>
      </div>

      <div class="global-numbers">
        <div class="global-numbers-colony">
          <div :class="getScaleCSS(lvl)" v-for="lvl in getValuesForParameter('colony')">{{ lvl.strValue }}</div>
        </div>

        <div class="global-numbers-logistics">
          <div :class="getScaleCSS(lvl, true)" v-for="lvl in getValuesForParameter('logistics')">{{ lvl.strValue }}</div>
        </div>

        <div class="global-numbers-mining">
          <div :class="getScaleCSS(lvl, true)" v-for="lvl in getValuesForParameter('mining')">{{ lvl.strValue }}</div>
        </div>

      </div>

      <div class="board" id="moon_board">
        <moon-space :space="curSpace" :key="'moon-space-'+curSpace.id" v-for="curSpace in getAllNonColonySpaces()"></moon-space>
      </div>
    </div>
    `,
});
//# sourceMappingURL=MoonBoard.js.map